<template>
  <div>
    <vx-card>
      <section>
        <h1 class="pb-5">Basic Info</h1>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Firstname</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="'required'"
              name="firstname"
              class="w-full"
              v-model="form.attendee.firstname"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('firstname')"
              >{{ errors.first("firstname") }}</span
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Lastname</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="'required'"
              name="lastname"
              class="w-full"
              v-model="form.attendee.lastname"
            />
            <span class="text-danger text-sm" v-show="errors.has('lastname')">{{
              errors.first("lastname")
            }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="'required'"
              name="email"
              type="email"
              class="w-full"
              v-model="form.attendee.email"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Phone</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input
              v-validate="'required'"
              name="phone"
              type="tel"
              class="w-full"
              v-model="form.attendee.phone"
              onkeypress="return /^[-+0-9]/i.test(event.key)"
              onpaste="return false"
            />
            <span class="text-danger text-sm" v-show="errors.has('phone')">{{
              errors.first("phone")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Publish Status</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  vs-name="publish_status"
                  v-model="form.attendee.publish_status"
                  :vs-value="`attendee_filter`"
                  >Yes</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  vs-name="publish_status"
                  v-model="form.attendee.publish_status"
                  :vs-value="false"
                  >No</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Profile Image (1:1)</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            {{ form.attendee.profile_img }}
            <template v-if="form.attendee.profile_img != null">
              <img :src="form.attendee.profile_img" />
            </template>
            <vs-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              accept="image/png, image/jpeg, image/jpg, image/webp"
              />
          </div>
        </div>
        <div class="vx-row pt-5">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button
              :disabled="!valid"
              class="mr-3 mb-2"
              @click.prevent="validateForm"
              >submit</vs-button
            >
          </div>
        </div>
      </section>
    </vx-card>
    <!--
    <vx-card class="mt-5" v-if="showDebug">
      <p class="text-center">For Souloutt Team Only</p>
      <vue-json-to-table :data="form"></vue-json-to-table>
    </vx-card>
    -->
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    valid: true,
    showDebug: false,
    form: {},
    filterList: []
  }),
  created() {
    setTimeout(() => {
      Service.Attendee.get(this.id, this.$route.query.e).then(res => {
        this.form = res.data;
        this.showDebug = true;
      });
    }, 1000);
  },
  methods: {
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "speaker",
        currentPage: 1,
        perPage: 50
      };

      let params = Object.keys(filterData)
        .map(key => key + "=" + filterData[key])
        .join("&");
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form.attendee
      };

      this.$vs.loading();
      Service.Attendee.update(data).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
          this.$router.push("/conferences/attendees");
        }
        this.$vs.loading.close();
      });
    }
  }
};
</script>
